export default import.meta.ROLLDOWN_FILE_URL_DUq8YoikZLXEejpNZ1KQvg